const loadMoreItems = {
    settings: {
        postsNumber: 0,
        offset: 9,
        postType: null,
        termId: 0,
        taxonomy: null,
        searchQuery: null
    },
    init: function() {
        let postItemsContainer = document.querySelector('.top-posts--ajax')
        if ( ! postItemsContainer ) {
            return;
        }

        this.settings.postType = postItemsContainer.dataset.postType;
        this.settings.termId = postItemsContainer.dataset.termId;
        this.settings.taxonomy = postItemsContainer.dataset.taxonomy;
        this.settings.searchQuery = postItemsContainer.dataset.searchQuery;
        this.loadMore();
    },
    loadMore: () => {
        const loadMoreBtn = document.querySelector('.top-posts-buttons #load-more');
        loadMoreBtn?.addEventListener('click', () => {
            loadMoreItems.getItems();
        })
    },
    getItems: () => {
        const loader = document.querySelector('.loader-container');
        const submit = document.querySelector('.top-posts-buttons #load-more');
        const ajax_data = {
            action: ajax.action_name,
            nonce: ajax.nonce,
            offset: loadMoreItems.settings.offset,
            post_type: loadMoreItems.settings.postType,
            term_id: loadMoreItems.settings.termId,
            taxonomy: loadMoreItems.settings.taxonomy,
            search_query: loadMoreItems.settings.searchQuery,
        };

        jQuery.ajax(
            {
                type: 'POST',
                url: ajax.ajax_url,
                data: ajax_data,
                beforeSend() {
                    loader.classList.add('var_active');
                    submit.classList.add('var_disabled');
                },
                success(data) {
                    const response = data.data;
                    const { html } = response;

                    const container = document.querySelector('.top-posts--ajax .top-posts__grid');
                    container.insertAdjacentHTML('beforeend', html);

                    loadMoreItems.buttonBehaviour(response.count);
                    loader.classList.remove('var_active');
                    submit.classList.remove('var_disabled');
                },
                error(xhr, status, errorThrown) {
                    alert('Something went wrong. Please try later.');
                    loader.classList.remove('var_active');
                    submit.classList.remove('var_disabled');
                },
            },
        );
    },
    buttonBehaviour: (count) => {
        const getDisplaiedPosts = document.querySelectorAll('.top-posts--ajax .top-post');
        loadMoreItems.settings.offset = getDisplaiedPosts.length;
        if (count === getDisplaiedPosts.length) {
            const submit = document.querySelector('.top-posts-buttons #load-more');
            submit.classList.add('var_hide');
        }
    },
};

loadMoreItems.init();
